
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.75ca3832.svg#" + id;
};
          